import { useEffect } from "react";
import { appStore } from "src/framework/store/AppStore";
import { ProjetosFormInicialHibrido } from "src/components/projetos/hibrido/FormInicialHibrido";
import { EdicaoLayoutHibrido } from "src/components/projetos/edicao/layouts/EdicaoLayoutHibrido";

const PAGE_TITLE = 'Edição projeto híbrido'

const ProjetosFormInicialHibridoEdicaoPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])
  
  return (
    <EdicaoLayoutHibrido>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetosFormInicialHibrido />
          </div>
        </div>
      </div>
    </EdicaoLayoutHibrido>
  );
};

export { ProjetosFormInicialHibridoEdicaoPage };